module.exports = __webpack_public_path__ + "img/806-10b717.png";